export default __webpack_public_path__ + "static/media/company.2c66a240.png";